import {ref} from 'vue';
import ApiService from '@core/services/ApiService';
import {defineStore} from 'pinia';

interface ErrorReport {
  message: string;
  type: 'HttpError' | 'VueError' | 'WindowError' | 'UnhandledRejectionError';
  component?: string;
  email?: string;
  errorCode?: string;
  environmentId?: string;
}

const MAX_STORED_ERRORS = 100;

export const useErrorReportStore = defineStore('ErrorReportStore', () => {
  const errors = ref<ErrorReport[]>([]);
  const api = ApiService.getApiInstance();

  function addError(error: ErrorReport) {
    errors.value.push(error);
    if (errors.value.length > MAX_STORED_ERRORS) {
      errors.value = errors.value.slice(-MAX_STORED_ERRORS);
    }
  }

  async function submitErrors(): Promise<boolean> {
    try {
      const response = await api.post(
        '/communications/errorreport',
        errors.value,
      );
      return response.status >= 200 && response.status < 300;
    } catch {
      return false;
    }
  }

  function clearErrors() {
    errors.value = [];
  }

  function $reset() {
    clearErrors();
  }

  return {
    errors,
    addError,
    submitErrors,
    clearErrors,
    $reset,
  };
});
